<template>
    <div>
        <generic-form-view
            rootPath="/v2/online_scan"
            :forms="forms"
            :columns="columns"
            :table_name="table_name"
            @onSubmitted="onSubmit"
            >

        </generic-form-view>
    </div>

</template>

<script>
import TableMeta from '@/models/OnlineScanTableMeta'
import GenericFormView from '@/views/base/GenericFormView'

export default {
  name: 'DatabaseEntryForm',
  components: {
    'generic-form-view': GenericFormView
    },
  data () {
    return {
        forms: TableMeta.input_view.forms,
        columns: TableMeta.columns,
        table_name: TableMeta.table_name
    }
  },
  watch: {

  },
  methods: {
    onSubmit (id, isNewRecord) {
      if(isNewRecord) {
        this.$router.replace({path: `/v2/online_scan/${id}/view`});
        
      }
    }
  },
  mounted () {
      
  }
}
</script>

